import React from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

function DialogForRejectedReason({
    open, 
    handleClose, 
    // handleConfirmButton,
    dialogTitle = "Motivos de rechazo",
    // buttonTextToDelete,
    buttonTextToCancel = "Cancel",
    dialogContentWidth = null,
    dialogContentMinHeight = null,
    // disabled,
    children
}) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {dialogTitle}
      </DialogTitle>
      <DialogContent
        style={{ width: dialogContentWidth, minHeight: dialogContentMinHeight }}
      >
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {buttonTextToCancel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogForRejectedReason;
